
import axios from 'axios'

export default async(organizationId) => {
    const response = await axios.get(`/organization/${organizationId}/category`)
    return response.data.categories
}
